/* tslint:disable */
/* eslint-disable */
/**
 * Spazious Backoffice API
 * Spazious private JSON:API v3 specification
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Apiv3backofficebookingeditorrfpDataAttributesVirtualObjects } from './apiv3backofficebookingeditorrfp-data-attributes-virtual-objects';
import { Apiv3backofficediagrammingvirtualmetingroomsetupsDataAttributesFurnitures } from './apiv3backofficediagrammingvirtualmetingroomsetups-data-attributes-furnitures';
/**
 * 
 * @export
 * @interface PlannerRFPAttributes
 */
export interface PlannerRFPAttributes {
    /**
     * 
     * @type {string}
     * @memberof PlannerRFPAttributes
     */
    accountType: PlannerRFPAttributesAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PlannerRFPAttributes
     */
    accountName: string;
    /**
     * 
     * @type {number}
     * @memberof PlannerRFPAttributes
     */
    attendees?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PlannerRFPAttributes
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof PlannerRFPAttributes
     */
    email: string;
    /**
     * 
     * @type {Array<Apiv3backofficediagrammingvirtualmetingroomsetupsDataAttributesFurnitures>}
     * @memberof PlannerRFPAttributes
     */
    furnitures?: Array<Apiv3backofficediagrammingvirtualmetingroomsetupsDataAttributesFurnitures>;
    /**
     * 
     * @type {string}
     * @memberof PlannerRFPAttributes
     */
    segmentationType?: PlannerRFPAttributesSegmentationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PlannerRFPAttributes
     */
    endDate?: string | null;
    /**
     * 
     * @type {any}
     * @memberof PlannerRFPAttributes
     */
    graph: any;
    /**
     * 
     * @type {Array<Apiv3backofficebookingeditorrfpDataAttributesVirtualObjects>}
     * @memberof PlannerRFPAttributes
     */
    virtualObjects?: Array<Apiv3backofficebookingeditorrfpDataAttributesVirtualObjects>;
    /**
     * 
     * @type {string}
     * @memberof PlannerRFPAttributes
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PlannerRFPAttributes
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof PlannerRFPAttributes
     */
    startDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlannerRFPAttributes
     */
    uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof PlannerRFPAttributes
     */
    virtualMeetingRoomSetup?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum PlannerRFPAttributesAccountTypeEnum {
    Agency = 'agency',
    Company = 'company',
    Individual = 'individual'
}
/**
    * @export
    * @enum {string}
    */
export enum PlannerRFPAttributesSegmentationTypeEnum {
    CONGRESS = 'CONGRESS',
    GROUPTRAVEL = 'GROUP_TRAVEL',
    INCENTIVES = 'INCENTIVES',
    MEETINGORCONFERENCE = 'MEETING_OR_CONFERENCE',
    SOCIALEVENT = 'SOCIAL_EVENT',
    WEDDING = 'WEDDING'
}

